<template>

  <div id="right-panel" class="right-panel fContainer">

    <SellHeader></SellHeader>

    <div class="content mt-3 fColumn">
      <div class="animated fadeIn fColumn">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
        <form action="/" method="post" id="form" class="userForm ajaxForm     fColumn">
          <div class="card     fColumn ">
            <div class="card-header     fHead">
              <strong>{{$t('setting.title')}}</strong>
              <div class="float-right">
              </div>
            </div>

            <div class=" scrollHeightEnable600x fContent ">

              <div class="card-body card-block fColumn pt-0 pb-0">
                <div class="row ">
                  <div class="col-12   ">
                    <label for="machinekey" class="#">{{$t('setting.machineId')}}</label>
                    <table class="w100">
                      <tr>
                        <td><input id="machinekey" v-model="machineId" class="machinekey w100 form-control" readonly="readonly"></td>
                        <td class="w1">
                          <button v-on:click="btnCopyMachineId()" type="button" class="btn btnCopy btn-lgX btn-success">
                            <i class="fa fa-copy"></i> {{$t('setting.copy')}}
                          </button>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <hr>


              <div class="card-body card-block fColumn pt-0 pb-0">
                <div class="row ">
                  <div class="col-12   ">
                    <h6>{{$t('setting.upperMenu')}}</h6>
                  </div>
                </div>
                <div class="row ">


                  <div class="col-12 col-md-6 offset-md-3 ">
                    <!--<label for="machinekey" class="#">{{$t('setting.customization')}}</label>-->
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.buyerButton')}}
                            </label>
                          </td>
                          <td class="w1">
                            <label class="switch switch-3d switch-info mr-3">
                              <input v-model="buyerButton" type="checkbox" class="switch-input">
                              <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 offset-md-3 ">
                    <!--<label for="machinekey" class="#">{{$t('setting.customization')}}</label>-->
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.businessPartnerButton')}}
                            </label>
                          </td>
                          <td class="w1">
                            <label class="switch switch-3d switch-info mr-3">
                              <input v-model="businessPartnerButton" type="checkbox" class="switch-input">
                              <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 offset-md-3 ">
                    <!--<label for="machinekey" class="#">{{$t('setting.transactions')}}</label>-->
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.transactionsButton')}}
                            </label>
                          </td>
                          <td class="w1">
                            <label class="switch switch-3d switch-info mr-3">
                              <input v-model="transactionsButton" type="checkbox" class="switch-input">
                              <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 offset-md-3 ">
                    <!--<label for="machinekey" class="#">{{$t('setting.closeButton')}}</label>-->
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.closesButton')}}
                            </label>
                          </td>
                          <td class="w1">
                            <label class="switch switch-3d switch-info mr-3">
                              <input v-model="closesButton" type="checkbox" class="switch-input">
                              <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>


                </div>
              </div>
              <hr>


              <div class="card-body card-block fColumn pt-0 pb-0">
                <div class="row ">
                  <div class="col-12   ">
                    <h6>{{$t('setting.printQuestion')}}</h6>
                  </div>
                </div>
                <div class="row ">

                  <div class="col-12 col-md-6 offset-md-3 ">
                    <!--<label for="machinekey" class="#">{{$t('setting.closeButton')}}</label>-->
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.printQuestionExit')}}
                            </label>
                          </td>
                          <td class="w1">
                            <label class="switch switch-3d switch-info mr-3">
                              <input v-model="printQuestionExit" type="checkbox" class="switch-input">
                              <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 offset-md-3 ">
                    <!--<label for="machinekey" class="#">{{$t('setting.closeButton')}}</label>-->
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.printQuestionPrint')}}
                            </label>
                          </td>
                          <td class="w1">
                            <label class="switch switch-3d switch-info mr-3">
                              <input v-model="printQuestionPrint" type="checkbox" class="switch-input">
                              <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <!--<div class="col-12 col-md-6 offset-md-3 ">-->
                  <!--&lt;!&ndash;<label for="machinekey" class="#">{{$t('setting.closeButton')}}</label>&ndash;&gt;-->
                  <!--<div class="fFix text-center">-->
                  <!--<table class="w100">-->
                  <!--<tr>-->
                  <!--<td class="text-right pr-3">-->
                  <!--<label class="">-->
                  <!--{{$t('setting.printQuestionDeliverynote')}}-->
                  <!--</label>-->
                  <!--</td>-->
                  <!--<td class="w1">-->
                  <!--<label class="switch switch-3d switch-info mr-3">-->
                  <!--<input v-model="printQuestionDeliverynote" type="checkbox" class="switch-input">-->
                  <!--<span class="switch-label"></span> <span class="switch-handle"></span>-->
                  <!--</label>-->
                  <!--</td>-->
                  <!--</tr>-->
                  <!--</table>-->
                  <!--</div>-->
                  <!--</div>-->
                  <div class="col-12 col-md-6 offset-md-3 ">
                    <!--<label for="machinekey" class="#">{{$t('setting.closeButton')}}</label>-->
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.printQuestionInvoice')}}
                            </label>
                          </td>
                          <td class="w1">
                            <label class="switch switch-3d switch-info mr-3">
                              <input v-model="printQuestionInvoice" type="checkbox" class="switch-input">
                              <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>


                  <!--<div class="col-12 col-md-6 offset-md-3   ">-->
                  <!--<div class="fFix text-center">-->
                  <!--<table class="w100">-->
                  <!--<tr>-->
                  <!--<td class="text-right pr-3">-->
                  <!--<label class="">-->
                  <!--{{$t('setting.printQuestion')}}-->
                  <!--</label>-->
                  <!--</td>-->
                  <!--<td class="w1">-->
                  <!--<select id="printQuestion" v-model="printQuestion" class="form-control" name="printQuestion">-->
                  <!--<option value="1">{{$t('setting.printQuestionOptions.justexit')}}</option>-->
                  <!--<option value="2">{{$t('setting.printQuestionOptions.justprint')}}</option>-->
                  <!--<option value="3">{{$t('setting.printQuestionOptions.exitAndPrint')}}</option>-->
                  <!--</select>-->
                  <!--</td>-->
                  <!--</tr>-->
                  <!--</table>-->
                  <!--</div>-->
                  <!--</div>-->

                </div>
              </div>
              <hr>

              <div class="card-body card-block fColumn pt-0 pb-0">
                <div class="row ">
                  <div class="col-12   ">
                    <h6>{{$t('setting.invoiceSettings')}}</h6>
                  </div>
                </div>
                <div class="row ">

                  <div class="col-12  ">
                    <div class="row form-group">
                      <div class="col col-6 extensionLine">
                        <label class="">
                          {{$t('setting.invoiceUseType')}}
                        </label>
                      </div>
                      <div class="col col-6">
                        <select id="invoiceUseType" v-model="invoiceUseType" class="form-control" name="printerFontSize">
                          <option value="0">{{$t('setting.invoiceUseNone')}}</option>
                          <!--<option value="1">{{$t('setting.invoiceUseInner')}}</option>-->
                          <option value="2">{{$t('setting.invoiceUseOuter')}}</option>
                          <option  value="3">{{$t('setting.invoiceUseSzamlazzhu')}}</option>
                          <!--v-if="hasszamlazzhu"-->
                        </select>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              <template v-if="invoiceUseType==='2'">
              <div class="card-body card-block fColumn pt-0 pb-15">
                <div class="row ">
                  <div class="col-12  ">
                    <h6>{{$t('setting.rounds')}}</h6>
                  </div>

                  <div class="col-12  ">
                    <div class="row form-group">
                      <div class="col col-6 extensionLine">
                        <label for="price_number_of_decimals" class=" form-control-label">{{$t('setting.price_number_of_decimals')}}</label>
                      </div>
                      <div class="col col-6">
                        <InputText id="price_number_of_decimals" name="price_number_of_decimals" v-model="price_number_of_decimals" v-validate="'required|integer'" hasToKeyboard="auto" value=""
                                   :title="$t('invoice.price_number_of_decimals')"
                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('price_number_of_decimals')"/>
                        <small class="unit form-text text-muted d-none"></small>
                      </div>
                    </div>
                  </div>
                  <div class="col-12  ">
                    <div class="row form-group">
                      <div class="col col-6 extensionLine">
                        <label for="sumprice_number_of_decimals" class=" form-control-label">{{$t('setting.sumprice_number_of_decimals')}}</label>
                      </div>
                      <div class="col col-6">
                        <InputText id="sumprice_number_of_decimals" name="sumprice_number_of_decimals" v-model="sumprice_number_of_decimals" v-validate="'required|integer'" hasToKeyboard="auto"
                                   value=""
                                   :title="$t('invoice.sumprice_number_of_decimals')"
                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('sumprice_number_of_decimals')"/>
                        <small class="unit form-text text-muted d-none"></small>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              </template>

              <div class="card-body card-block fColumn pt-0 pb-15">
                <div class="row ">
                  <div class="col-12  ">
                    <h6>{{$t('setting.dataentry')}}</h6>
                  </div>
                  <div class="col-12  ">
                    <div class="row form-group">
                      <div class="col col-6 extensionLine">
                        <label for="minProductPrice" class=" form-control-label">{{$t('setting.minProductPrice')}}</label>
                      </div>
                      <div class="col col-6">
                        <InputText id="minProductPrice" name="minProductPrice" v-model="minProductPrice" v-validate="'required|integer'" hasToKeyboard="auto" value=""
                                   :title="$t('invoice.minProductPrice')"
                                   placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('minProductPrice')"/>
                        <small class="unit form-text text-muted d-none"></small>
                      </div>
                    </div>
                  </div>

                </div>
              </div>




              <hr>

              <div class="card-body card-block fColumn pt-0 pb-15">
                <div class="row ">
                  <!--<div class="col-12  ">-->
                  <!--<h6>{{$t('setting.boxExtraClassText')}}</h6>-->
                  <!--</div>-->
                  <div class="col-12  ">
                    <div class="row form-group">
                      <div class="col col-6 extensionLine">
                        <label for="minProductPrice" class=" form-control-label">{{$t('setting.boxExtraClassText')}}</label>
                      </div>
                      <div class="col col-6">
                        <select id="boxExtraClass" v-model="boxExtraClass" class="form-control" name="boxExtraClass">
                          <option value="">{{$t('setting.boxExtraClassValues.default')}}</option>
                          <option value="displaytype1">{{$t('setting.boxExtraClassValues.displaytype1')}}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              <hr>
              <div class="card-body card-block fColumn pt-0 pb-0">
                <div class="row ">
                  <div class="col-12   ">
                    <h6>{{$t('setting.closesSettings')}}</h6>
                  </div>
                </div>
                <div class="row ">

                  <div class="col-12 col-md-6 offset-md-3 ">
                    <!--<label for="machinekey" class="#">{{$t('setting.closeButton')}}</label>-->
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.closesButtonItemizedList')}}
                            </label>
                          </td>
                          <td class="w1">
                            <label class="switch switch-3d switch-info mr-3">
                              <input v-model="closesButtonItemizedList" type="checkbox" class="switch-input">
                              <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                </div>
              </div>
              <hr>


              <div class="card-body card-block fColumn pt-0 pb-0">
                <div class="row ">
                  <div class="col-12   ">
                    <h6>{{$t('setting.universalsettings')}}</h6>
                  </div>
                </div>
                <div class="row ">


                  <div class="col-12 col-md-6 offset-md-3   ">
                    <!--<label for="machinekey" class="#">{{$t('setting.customization')}}</label>-->
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.keyboardOnOff')}}
                            </label>
                          </td>
                          <td class="w1">
                            <label class="switch switch-3d switch-info mr-3">
                              <input v-model="keyboardEnable" type="checkbox" class="switch-input">
                              <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <div class="col-12 col-md-6 offset-md-3   ">
                    <!--<label for="machinekey" class="#">{{$t('setting.customization')}}</label>-->
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.hasselltext')}}
                            </label>
                          </td>
                          <td class="w1">
                            <label class="switch switch-3d switch-info mr-3">
                              <input v-model="hasselltext" type="checkbox" class="switch-input">
                              <span class="switch-label"></span> <span class="switch-handle"></span>
                            </label>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                  <!--<div class="col-12 col-md-6 offset-md-3    ">-->
                    <!--&lt;!&ndash;<label for="machinekey" class="#">{{$t('setting.closeButton')}}</label>&ndash;&gt;-->
                    <!--<div class="fFix text-center">-->
                      <!--<table class="w100">-->
                        <!--<tr>-->
                          <!--<td>-->
                            <!--<label class="text-right pr-3">-->
                              <!--{{$t('setting.useTwoMonitor')}}-->
                            <!--</label>-->
                          <!--</td>-->
                          <!--<td class="w1">-->
                            <!--<label class="switch switch-3d switch-info mr-3">-->
                              <!--<input v-model="useTwoMonitor" type="checkbox" class="switch-input">-->
                              <!--<span class="switch-label"></span> <span class="switch-handle"></span>-->
                            <!--</label>-->
                          <!--</td>-->
                        <!--</tr>-->

                      <!--</table>-->
                    <!--</div>-->
                  <!--</div>-->

                  <!--<div class="col-12    ">-->
                    <!--&lt;!&ndash;<label for="machinekey" class="#">{{$t('setting.closeButton')}}</label>&ndash;&gt;-->
                    <!--<div class="fFix text-center">-->
                      <!--<table class="w100">-->

                        <!--<tr>-->
                          <!--<td colspan="2" class="text-right">-->
                            <!--<button v-on:click="openSecondScreen()" type="button" class="btn btn-lgX btn-info">-->
                              <!--<i class="fa fa-desktop"></i> {{$t('setting.openSecondScreen')}}-->
                            <!--</button>-->
                          <!--</td>-->
                        <!--</tr>-->

                      <!--</table>-->
                    <!--</div>-->
                  <!--</div>-->


                </div>
              </div>
              <hr>


              <div class="card-body card-block fColumn pt-0 pb-0">
                <div class="row ">
                  <div class="col-12   ">
                    <h6>{{$t('setting.printerFontSize')}}</h6>
                  </div>
                  <div class="col-12 pt-2">
                    <h6>{{$t('setting.printerPaddingInfo')}}</h6>
                  </div>
                </div>

                <div class="row row pb-3 pt-3">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6   ">
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.printerPaddingTop')}}
                            </label>
                          </td>
                          <td>
                            <select id="printerPaddingTop" v-model="printerPaddingTop" class="form-control" name="printerPaddingTop">
                              <option value="0">0</option>
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="15">15</option>
                              <option value="20">20</option>
                              <option value="25">25</option>
                              <option value="30">30</option>
                              <option value="35">35</option>
                              <option value="40">40</option>
                              <option value="45">45</option>
                              <option value="50">50</option>
                              <option value="55">55</option>
                              <option value="60">60</option>
                              <option value="65">65</option>
                              <option value="70">70</option>
                              <option value="75">75</option>
                            </select>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6   ">
                    <div class="fFix text-center">
                    </div>
                  </div>
                </div>

                <div class="row ">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6   ">
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.printerPaddingLeft')}}
                            </label>
                          </td>
                          <td>
                            <select id="printerPaddingLeft" v-model="printerPaddingLeft" class="form-control" name="printerPaddingLeft">
                              <option value="0">0</option>
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="15">15</option>
                              <option value="20">20</option>
                              <option value="25">25</option>
                              <option value="30">30</option>
                              <option value="35">35</option>
                              <option value="40">40</option>
                              <option value="45">45</option>
                              <option value="50">50</option>
                              <option value="55">55</option>
                              <option value="60">60</option>
                              <option value="65">65</option>
                              <option value="70">70</option>
                              <option value="75">75</option>
                            </select>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6   ">
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.printerPaddingRight')}}
                            </label>
                          </td>
                          <td>
                            <select id="printerPaddingRight" v-model="printerPaddingRight" class="form-control" name="printerPaddingRight">
                              <option value="0">0</option>
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="15">15</option>
                              <option value="20">20</option>
                              <option value="25">25</option>
                              <option value="30">30</option>
                              <option value="35">35</option>
                              <option value="40">40</option>
                              <option value="45">45</option>
                              <option value="50">50</option>
                              <option value="55">55</option>
                              <option value="60">60</option>
                              <option value="65">65</option>
                              <option value="70">70</option>
                              <option value="75">75</option>
                            </select>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>


                </div>


              </div>
              <div class="card-body card-block fColumn pt-0 pb-0">
                <div class="row ">
                  <div class="col-12   ">
                    <h6>{{$t('setting.printerFontSize')}}</h6>
                  </div>
                </div>
                <div class="row ">
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6  ">
                    <div class="fFix text-center">
                      <table class="w100">
                        <tr>
                          <td class="text-right pr-3">
                            <label class="">
                              {{$t('setting.printerFontSize')}}
                            </label>
                          </td>
                          <td>
                            <select id="printerFontSize" v-model="printerFontSize" class="form-control" name="printerFontSize">
                              <option value="6">6</option>
                              <option value="8">8</option>
                              <option value="10">10</option>
                              <option value="11">11</option>
                              <option value="12">12</option>
                              <option value="13">13</option>
                              <option value="14">14</option>
                              <option value="16">16</option>
                              <option value="18">18</option>
                              <option value="22">22</option>
                              <option value="28">28</option>
                              <option value="34">34</option>
                              <option value="55">55</option>
                            </select>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 col-md-6 col-lg-6 text-right ">
                    <!--<button type="button" class="btn btn-info btn-lgx btn-reprint float-right" v-on:click="reprint()">-->
                      <!--<i class="fa fa-print"></i> {{$t('setting.printLastSell')}}-->
                    <!--</button>-->
                  </div>

                </div>
              </div>


              <!---->
              <!--<div class="card-body card-block fColumn pt-0 pb-0">-->
              <!--<div class="row ">-->

              <!--</div>-->
              <!--</div>-->

              <!--<hr>-->

              <!--<div class="card-body card-block fColumn pt-0 pb-0">-->

              <!--</div>-->
              <!--<hr>-->
              <!---->


              <hr>




              <!--<div class="card-body card-block fColumn pt-0 pb-0">-->
              <!--<div class="row ">-->
              <!--<div class="col-12   ">-->
              <!--<label for="machinekey" class="#">{{$t('setting.syncHandling')}}</label>-->
              <!--<div class="fFix text-center">-->
              <!--<button v-on:click="btnSyncOn()" type="button" class="btn btnSyncOn btn-lgX btn-warning">-->
              <!--<i class="fa fa-play"></i> {{$t('setting.btnSyncOn')}}-->
              <!--</button>-->
              <!--<button v-on:click="btnSyncOff()" type="button" class="btn btnSyncOff btn-lgX btn-warning">-->
              <!--<i class="fa fa-stop"></i> {{$t('setting.btnSyncOff')}}-->
              <!--</button>-->
              <!--<button v-on:click="btnSyncDo()" type="button" class="btn btnSyncDo btn-lgX btn-warning">-->
              <!--<i class="fa fa-step-forward"></i> {{$t('setting.btnSyncDo')}}-->
              <!--</button>-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
              <!--<hr>-->
              <!--<div class="card-body card-block fColumn pt-0 pb-15">-->
              <!--<div class="row ">-->
              <!--<div class="col-12   ">-->
              <!--<h6>{{$t('setting.delDataTitle')}}</h6>-->
              <!--<div class="fFix text-center">-->
              <!--<button v-on:click="btnDelFullData()" type="button" class="btn btnDelFullData btn-lgX btn-danger">-->
              <!--<i class="fa fa-eraser"></i> {{$t('setting.delFullData')}}-->
              <!--</button>-->
              <!--&lt;!&ndash;<button v-on:click="btnDelData()" type="button" class="btn btnDelData btn-lgX btn-danger">&ndash;&gt;-->
              <!--&lt;!&ndash;<i class="fa fa-dot-circle-o"></i> {{$t('setting.delData')}}&ndash;&gt;-->
              <!--&lt;!&ndash;</button>&ndash;&gt;-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
              <!--</div>-->
              <!--<hr>-->





              <!--<div class="card-body card-block fColumn pt-0 pb-15">-->
                <!--<div class="row ">-->
                  <!--<div class="col-12 col-sm-6 col-md-5 col-lg-5 ">-->
                    <!--<h6>{{$t('setting.updateSettings')}}</h6>-->
                    <!--<div class="fFix text-center">-->
                      <!--<table>-->
                        <!--<tr>-->
                          <!--<td>-->
                            <!--<label class="">-->
                              <!--{{$t('setting.autoUpdateOnOff')}}-->
                            <!--</label>-->
                          <!--</td>-->
                          <!--<td>&nbsp;&nbsp;-->
                            <!--<label class="switch switch-3d switch-info mr-3">-->
                              <!--<input v-model="autoUpdateOnOff" type="checkbox" class="switch-input">-->
                              <!--<span class="switch-label"></span> <span class="switch-handle"></span>-->
                            <!--</label>-->
                          <!--</td>-->
                        <!--</tr>-->
                      <!--</table>-->
                    <!--</div>-->
                  <!--</div>-->
                <!--</div>-->
              <!--</div>-->

            </div>

            <div class="card-footer text-center fFix">
            </div>
          </div>
        </form>
      </div><!-- .animated -->
    </div><!-- .content -->
  </div>

</template>

<script>
  //  import Api from '@/api/Api';
  import LngChooser from '@/components/LngChooser.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Helper from '@/helper/Helper';
  import InputText from '@/components/InputText.vue';
  import SellHeader from "../components/SellHeader";
  //    const machineId = require('node-machine-id').machineId;
  //    const machineIdSync = require('node-machine-id').machineIdSync;
  //    import SyncHandler from '@/sync/syncHandler';
  //    const {ipcRenderer} = require('electron');

  export default {
    name: 'Setting',
//        roles: [5, 6, 7, 8, 9, 10],
    data() {
      return {
        machineId: "", //machineIdSync(),
        keyboardEnable: true,
        hasselltext: false,
        hasszamlazzhu: false,
//                keyboardOnOff: true,
        data: {},
        AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        },
        printerPaddingLeft: 0,
        printerPaddingRight: 0,
        printerPaddingTop: 0,
        printerFontSize: 0,
        printQuestion: '',
        minProductPrice: "0",
        boxExtraClass: "",
        price_number_of_decimals: "2",
        sumprice_number_of_decimals: "2",


        buyerButton: true,
        invoiceUseType: "2",
        businessPartnerButton: true,
        transactionsButton: true,
        closesButton: true,
        closesButtonItemizedList: false,
        useTwoMonitor: false,
        autoUpdateOnOff: true,
        printQuestionExit: true,
        printQuestionPrint: true,
        printQuestionDeliverynote: false,
        printQuestionInvoice: true,

      };
    },
    mounted() {
      const modul = this;
      console.log(this.$route.name + " mounded");
      modul.roles = [5, 6, 7, 8, 9, 10];
      // settings re read
      modul.machineId = localStorage.getItem("browserIdentifier");

      if (modul.$store && modul.$store.state && modul.$store.state.integrationconnection && modul.$store.state.integrationconnection.connect_key) {
        modul.hasszamlazzhu = true;
      }

      try {
        modul.$eventBus.$emit('globalReadAndSetSettings', {});
      }
      catch (err) {
        console.log("catched error - globalReadAndSetSettings");
      }
      const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
      if (!Helper.checkRoles(modul.roles, role)) {
        modul.$router.push({name: "login"})
      }
      if (localStorage) {
        let boxExtraClass = localStorage.getItem("boxExtraClass");
        if (boxExtraClass === null || boxExtraClass === void 0) {
          localStorage.setItem("boxExtraClass", "");
          boxExtraClass = "";
        }
        modul.boxExtraClass = boxExtraClass;
        let minProductPrice = localStorage.getItem("minProductPrice");
        if (minProductPrice === null || minProductPrice === void 0) {
          localStorage.setItem("minProductPrice", "0");
          minProductPrice = "0";
        }
        modul.minProductPrice = minProductPrice;
        let price_number_of_decimals = localStorage.getItem("price_number_of_decimals");
        if (price_number_of_decimals === null || price_number_of_decimals === void 0) {
          localStorage.setItem("price_number_of_decimals", 2);
          price_number_of_decimals = 2;
        }
        modul.price_number_of_decimals = price_number_of_decimals;

        let sumprice_number_of_decimals = localStorage.getItem("sumprice_number_of_decimals");
        if (sumprice_number_of_decimals === null || sumprice_number_of_decimals === void 0) {
          localStorage.setItem("sumprice_number_of_decimals", 2);
          sumprice_number_of_decimals = 2;
        }
        modul.sumprice_number_of_decimals = sumprice_number_of_decimals;

        let keyboardEnable = localStorage.getItem("keyboardEnable");
        if (keyboardEnable === null || keyboardEnable === void 0) {
          localStorage.setItem("keyboardEnable", true);
          keyboardEnable = localStorage.getItem("keyboardEnable");
        }
        modul.keyboardEnable = keyboardEnable === "true";
        let hasselltext = localStorage.getItem("hasselltext");
        if (hasselltext === null || hasselltext === void 0) {
          localStorage.setItem("hasselltext", false);
          hasselltext = localStorage.getItem("hasselltext");
        }
        modul.hasselltext = hasselltext === "true";
        let autoUpdateOnOff = localStorage.getItem("autoUpdateOnOff");
        if (autoUpdateOnOff === null || autoUpdateOnOff === void 0) {
          localStorage.setItem("autoUpdateOnOff", true);
          autoUpdateOnOff = localStorage.getItem("autoUpdateOnOff");
        }
        modul.autoUpdateOnOff = (autoUpdateOnOff === "true");
        let printQuestionExit = localStorage.getItem("printQuestionExit");
        if (printQuestionExit === null || printQuestionExit === void 0) {
          localStorage.setItem("printQuestionExit", true);
          printQuestionExit = localStorage.getItem("printQuestionExit");
        }
        modul.printQuestionExit = (printQuestionExit === "true");
        let printQuestionPrint = localStorage.getItem("printQuestionPrint");
        if (printQuestionPrint === null || printQuestionPrint === void 0) {
          localStorage.setItem("printQuestionPrint", true);
          printQuestionPrint = localStorage.getItem("printQuestionPrint");
        }
        modul.printQuestionPrint = (printQuestionPrint === "true");
        let printQuestionDeliverynote = localStorage.getItem("printQuestionDeliverynote");
        if (printQuestionDeliverynote === null || printQuestionDeliverynote === void 0) {
          localStorage.setItem("printQuestionDeliverynote", false);
          printQuestionDeliverynote = localStorage.getItem("printQuestionDeliverynote");
        }
        modul.printQuestionDeliverynote = (printQuestionDeliverynote === "true");
        let printQuestionInvoice = localStorage.getItem("printQuestionInvoice");
        if (printQuestionInvoice === null || printQuestionInvoice === void 0) {
          localStorage.setItem("printQuestionInvoice", true);
          printQuestionInvoice = localStorage.getItem("printQuestionInvoice");
        }
        modul.printQuestionInvoice = (printQuestionInvoice === "true");
        if (localStorage.getItem("printerPaddingLeft")) {
          modul.printerPaddingLeft = Number(localStorage.getItem("printerPaddingLeft"));
        } else {
          modul.printerPaddingLeft = 0;
          localStorage.setItem("printerPaddingLeft", modul.printerPaddingLeft);
        }
        if (localStorage.getItem("printerPaddingRight")) {
          modul.printerPaddingRight = Number(localStorage.getItem("printerPaddingRight"));
        } else {
          modul.printerPaddingRight = 0;
          localStorage.setItem("printerPaddingRight", modul.printerPaddingRight);
        }
        if (localStorage.getItem("printerPaddingTop")) {
          modul.printerPaddingTop = Number(localStorage.getItem("printerPaddingTop"));
        } else {
          modul.printerPaddingTop = 0;
          localStorage.setItem("printerPaddingTop", modul.printerPaddingTop);
        }
        if (localStorage.getItem("printerFontSize")) {
          modul.printerFontSize = Number(localStorage.getItem("printerFontSize"));
        } else {
          modul.printerFontSize = 16;
          localStorage.setItem("printerFontSize", modul.printerFontSize);
        }
        if (localStorage.getItem("printQuestion")) {
          modul.printQuestion = localStorage.getItem("printQuestion");
        } else {
          modul.printQuestion = 3; // for modify the default value use the sell2 screen too
          localStorage.setItem("printQuestion", modul.printQuestion);
        }
        if (localStorage.getItem("buyerButton")) {
          if (localStorage.getItem("buyerButton") === "false") {
            modul.buyerButton = false;
          } else {
            modul.buyerButton = localStorage.getItem("buyerButton");
          }
        } else {
          modul.buyerButton = true;
          localStorage.setItem("buyerButton", modul.buyerButton);
        }
        if (localStorage.getItem("invoiceUseType")) {
          modul.invoiceUseType = localStorage.getItem("invoiceUseType");
        } else {
          modul.invoiceUseType = "2";
          localStorage.setItem("invoiceUseType", modul.invoiceUseType);
        }
        if (localStorage.getItem("businessPartnerButton")) {
          if (localStorage.getItem("businessPartnerButton") === "false") {
            modul.businessPartnerButton = false;
          } else {
            modul.businessPartnerButton = localStorage.getItem("businessPartnerButton");
          }
        } else {
          modul.businessPartnerButton = true;
          localStorage.setItem("businessPartnerButton", modul.businessPartnerButton);
        }
        if (localStorage.getItem("transactionsButton")) {
          if (localStorage.getItem("transactionsButton") === "false") {
            modul.transactionsButton = false;
          } else {
            modul.transactionsButton = localStorage.getItem("transactionsButton");
          }

//                    modul.transactionsButton = localStorage.getItem("transactionsButton");
        } else {
          modul.transactionsButton = true;
          localStorage.setItem("transactionsButton", modul.transactionsButton);
        }
        if (localStorage.getItem("closesButton")) {
          if (localStorage.getItem("closesButton") === "false") {
            modul.closesButton = false;
          } else {
            modul.closesButton = localStorage.getItem("closesButton");
          }
//                    modul.closesButton = localStorage.getItem("closesButton");
        } else {
          modul.closesButton = true;
          localStorage.setItem("closesButton", modul.closesButton);
        }
        if (localStorage.getItem("closesButtonItemizedList")) {
          if (localStorage.getItem("closesButtonItemizedList") === "true" || localStorage.getItem("closesButtonItemizedList") === true) {
            modul.closesButtonItemizedList = true;
          } else {
            modul.closesButtonItemizedList = false;
          }
//                    modul.closesButtonItemizedList = localStorage.getItem("closesButtonItemizedList");
        } else {
          modul.closesButtonItemizedList = false;
          localStorage.setItem("closesButtonItemizedList", modul.closesButtonItemizedList);
        }
        if (localStorage.getItem("useTwoMonitor")) {
          if (localStorage.getItem("useTwoMonitor") === "true" || localStorage.getItem("useTwoMonitor") === true) {
            modul.useTwoMonitor = true;
          } else {
            modul.useTwoMonitor = false;
          }
//                    modul.useTwoMonitor = localStorage.getItem("useTwoMonitor");
        } else {
          modul.useTwoMonitor = false;
          localStorage.setItem("useTwoMonitor", modul.useTwoMonitor);
        }
      }
      console.log(this.$route.name + " mounded");
    },
    watch: {
      boxExtraClass: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("boxExtraClass", newData);
        }
      },
      minProductPrice: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("minProductPrice", newData);
        }
      },
      price_number_of_decimals: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("price_number_of_decimals", newData);
        }
      },
      sumprice_number_of_decimals: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("sumprice_number_of_decimals", newData);
        }
      },
      buyerButton: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("buyerButton", newData);
        }
      },
      invoiceUseType: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("invoiceUseType", newData);
        }
      },
      businessPartnerButton: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("businessPartnerButton", newData);
        }
      },
      transactionsButton: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("transactionsButton", newData);
        }
      },
      closesButton: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("closesButton", newData);
        }
      },
      closesButtonItemizedList: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("closesButtonItemizedList", newData);
        }
      },
      useTwoMonitor: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("useTwoMonitor", newData);
        }
      },
      keyboardEnable: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("keyboardEnable", newData);
        }
      },
      hasselltext: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("hasselltext", newData);
        }
      },
      autoUpdateOnOff: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("autoUpdateOnOff", newData);
        }
      },
      printQuestionExit: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("printQuestionExit", newData);
        }
      },
      printQuestionPrint: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("printQuestionPrint", newData);
        }
      },
      printQuestionDeliverynote: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("printQuestionDeliverynote", newData);
        }
      },
      printQuestionInvoice: function (newData, oldData) {
        if (localStorage) {
          localStorage.setItem("printQuestionInvoice", newData);
        }
      },
      printerPaddingLeft: function (newData, oldData) {
//                if (newData !== oldData) {
        if (localStorage) {
          localStorage.setItem("printerPaddingLeft", newData);
        }
//                }
      },
      printerPaddingRight: function (newData, oldData) {
//                if (newData !== oldData) {
        if (localStorage) {
          localStorage.setItem("printerPaddingRight", newData);
        }
//                }
      },
      printerPaddingTop: function (newData, oldData) {
//                if (newData !== oldData) {
        if (localStorage) {
          localStorage.setItem("printerPaddingTop", newData);
        }
//                }
      },
      printerFontSize: function (newData, oldData) {
//                if (newData !== oldData) {
        if (localStorage) {
          localStorage.setItem("printerFontSize", newData);
        }
//                }
      },
      printQuestion: function (newData, oldData) {
//                if (newData !== oldData) {
        if (localStorage) {
          localStorage.setItem("printQuestion", newData);
        }
//                }
      },
    },
    methods: {
      openSecondScreen: function () {
//        const mode = this.$router.mode;
//                ipcRenderer.send('SecondaryDisplay', 'open');
//        this.$router.mode = mode;
      },
      btnSyncOn: function () {
        const modul = this;
        if (confirm(modul.$t("setting.confirmTextSyncOn"))) {
//                    SyncHandler.handle({job: 'start'})
        }
      },
      btnSyncOff: function () {
        const modul = this;
        if (confirm(modul.$t("setting.confirmTextSyncOff"))) {
//                    SyncHandler.handle({job: 'stop'})
        }
      },
      btnSyncDo: function () {
        const modul = this;
        if (confirm(modul.$t("setting.confirmTextSyncDo"))) {
//                    SyncHandler.handle({job: 'do'})
        }
      },
      btnDelFullData: function () {
        const modul = this;
        if (confirm(modul.$t("setting.confirmTextDelData"))) {
          window.db.reformatDataBase()
        }
      },
      btnCopyMachineId: function () {
        const modul = this;
        let text = this.machineId;
        const copyText = document.createElement("input");
        const body = document.getElementsByTagName("body")[0];
        body.append(copyText);
        copyText.value = text;
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        copyText.remove();
        modul.AlertInPage.msg = "setting.alertCopyText";
        modul.AlertInPage.type = "success";
        setTimeout(function (e) {
          modul.AlertInPage.msg = "";
        }, Number(5000));
      },
      reprint: function () {
        const modul = this;
        modul.getLastSellId(function (err, res) {
          if (res && res[0] && res[0].id) {
            const sellprintId = res[0].id;
            modul.$router.push({
              name: "sellprint", params: {
                sellId: sellprintId,
              }
            });

          }
        });
      },
      getLastSellId: function (cb, id) {
        console.log("getLastSellId");
        window.db.select(
          function (err, res) {
            cb(err, window.db.convertResToArray(err, res))
          }
          , "sell ", "id", "1", "id desc", "1");
      },

    },
    components: {
      SellHeader,
      InputText,
      LngChooser,
      AlertInPage,

    },
  };
</script>

